import { getImageAltText, PatchNoteImageDialog, resolveImageUrl } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const mountPatchNoteImageDialog = mountDialogUIReactComponent(PatchNoteImageDialog);
export async function showPatchNoteImageDialog({ title, imagePath }) {
    try {
        const imageUrl = await resolveImageUrl(imagePath);
        mountPatchNoteImageDialog({
            title: title,
            imageUrl: imageUrl,
            alt: getImageAltText(imagePath)
        });
    } catch  {
        return;
    }
}
